var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9503 40.2058C14.8095 40.63 14.8876 40.9796 15.2038 41.3327C15.5701 41.7417 16.2429 42.0908 17.06 42.0908L38.94 42.0908C39.7571 42.0908 40.4299 41.7417 40.7962 41.3327C41.1124 40.9796 41.1905 40.63 41.0497 40.2058C40.363 38.1364 39.2365 36.2434 37.7388 34.6783C35.1383 31.961 31.633 30.4538 28 30.4538C24.367 30.4538 20.8617 31.961 18.2612 34.6783C16.7635 36.2434 15.637 38.1364 14.9503 40.2058ZM12.2173 39.2818C11.2062 42.3289 13.8764 45 17.06 45L38.94 45C42.1236 45 44.7938 42.3289 43.7827 39.2818C42.963 36.8114 41.6147 34.5411 39.8118 32.6571C37.8157 30.5713 35.3665 29.0679 32.706 28.2515C35.5191 26.6586 37.4118 23.6814 37.4118 20.2714C37.4118 15.1835 33.198 11.0588 28 11.0588C22.8021 11.0588 18.5883 15.1835 18.5883 20.2714C18.5883 23.6814 20.4809 26.6586 23.2941 28.2515C20.6335 29.0679 18.1843 30.5713 16.1882 32.6571C14.3853 34.5411 13.037 36.8114 12.2173 39.2818ZM21.5295 20.2714C21.5295 23.7694 24.4264 26.6051 28 26.6051C31.5736 26.6051 34.4706 23.7694 34.4706 20.2714C34.4706 16.7734 31.5736 13.9378 28 13.9378C24.4264 13.9378 21.5295 16.7734 21.5295 20.2714Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 26.5,
    stroke: "white",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.cdd5694bcfbdd048b26e2b29dfe228d1.svg";
export { ForwardRef as ReactComponent };